module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NPFug0/tc-custom/9780765392657.jpg?1731797218314",
      "alt": "This image is the cover for the book All Those Explosions Were Someone Else's Fault"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("All Those Explosions Were Someone Else's Fault\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Monsters are real."), _c('br'), _vm._v("But so are heroes."), _c('br'), _c('br'), _vm._v("Sparks are champions of weird science. Boasting capes and costumes and amazing super-powers that only make sense if you don’t think about them too hard, they fight an eternal battle for truth and justice . . . mostly."), _c('br'), _c('br'), _vm._v("Darklings are creatures of myth and magic: ghosts, vampires, were-beasts, and the like. Their very presence warps reality. Doors creak at their approach. Cobwebs gather where they linger. "), _c('br'), _c('br'), _vm._v("Kim Lam is an ordinary college student until a freak scientific accident (what else?) transforms Kim and three housemates into Sparks—and drafts them into the never-ending war between the Light and Dark.  They struggle to master their new abilities—and (of course) to design cool costumes and come up with great hero-names."), _c('br'), _c('br'), _vm._v("Turns out that “accident” was just the first salvo in a Mad Genius’s latest diabolical scheme. Now it’s up to four newbie heroes to save the day, before they even have a chance to figure out what their team’s name should be!"), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Alan Gardner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James A. Gardner is the author of seven science fiction novels and one collection of short stories. Gardner lives in Kitchener, Ontario, Canada.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0